import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

export type UsageRateTooltipProps = {
  label: string;
  value: number;
  marketShare: string;
  ranking?: string;
};

export const UsageRateTooltip = ({
  label,
  value,
  marketShare,
  ranking,
}: UsageRateTooltipProps) => {
  return (
    <Box
      sx={{
        p: 2,
        minWidth: 220,
        background: "linear-gradient(180deg, #0f172a 0%, #020617 100%)",
        borderRadius: 2,
        color: "#fff",
        boxShadow: "0px 14px 40px rgba(0,0,0,0.55)",
      }}
    >
      <Typography fontWeight={700} mb={1}>
        {label}
      </Typography>

      <Typography variant="body2" color="#cbd5e1">
        Transactions:{" "}
        <Box component="span" color="#38bdf8" fontWeight={600}>
          {value.toLocaleString()}
        </Box>
      </Typography>

      <Typography variant="body2" color="#cbd5e1">
        Market Share:{" "}
        <Box component="span" color="#38bdf8" fontWeight={600}>
          {marketShare}
        </Box>
      </Typography>

      {ranking && (
        <Box mt={1} pt={1} borderTop="1px solid rgba(255,255,255,0.12)">
          <Typography variant="body2">
            Ranking:{" "}
            <Box component="span" color="#facc15" fontWeight={700}>
              {ranking}
            </Box>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default UsageRateTooltip;
